import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { DescriptionIcon } from '@trello/nachos/icons/description';
import { forTemplate } from '@trello/i18n';
import {
  MarkdownContentType,
  TrelloMarkdown,
} from 'app/src/components/TrelloMarkdown';
import {
  FriendlyLinksRenderer,
  FRIENDLY_LINKS_CONTAINER_CLASS,
} from 'app/gamma/src/components/friendly-links-renderer';

import styles from './DescriptionSection.less';

const format = forTemplate('card_detail');

const MAX_DESCRIPTION_LENGTH = 1800;

interface DescriptionSectionProps {
  description: string;
  descriptionData?: string | null;
}

export const DescriptionSection = ({
  description,
  descriptionData,
}: DescriptionSectionProps) => {
  const [isOpen, setIsOpen] = useState(
    description.length <= MAX_DESCRIPTION_LENGTH,
  );

  const showMore = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const customEmojis = {
    textData: JSON.parse(descriptionData || '{ "emoji": {} }'),
  };

  return (
    <div className={styles.descriptionSection}>
      <div className={styles.descriptionIcon}>
        <DescriptionIcon size="large" />
      </div>
      <h3 className={styles.heading} dir="auto">
        {format('description')}
      </h3>
      <div
        className={classNames(styles.descriptionContent, isOpen && styles.open)}
      >
        <button className={styles.descriptionMask} onClick={showMore}>
          <div className={styles.showMoreButton}>
            {format('show-full-description')}
          </div>
        </button>
        <div className={styles.description}>
          <FriendlyLinksRenderer>
            <div className={FRIENDLY_LINKS_CONTAINER_CLASS}>
              <TrelloMarkdown
                contentType={MarkdownContentType.Description}
                text={description}
                options={customEmojis}
              />
            </div>
          </FriendlyLinksRenderer>
        </div>
      </div>
    </div>
  );
};
